import * as React from 'react'

import { Textarea } from '@factorialco/f0-react/dist/experimental'

import { observer } from 'mobx-react'

import { ContentEditorProps } from 'modules/trainings/components/content/types'
import { QuizBlock } from 'modules/trainings/lib/content/QuizBlock'

const QuizBlockEditor = observer(({ contentItem: quiz }: ContentEditorProps<QuizBlock>) => {
  const ensureFormExists = () => {
    if (!quiz.form) {
      quiz.form = {
        id: null,
        title: quiz.title,
        description: undefined,
        resourceId: null,
        resourceType: 'Trainings::Training',
        formType: 'quiz',
        elements: [],
      }
    }
  }

  return (
    <>
      <Textarea
        label={'Title'}
        onChange={(value: string) => {
          ensureFormExists()
          quiz.title = value
          if (quiz.form) {
            quiz.form.title = value
          }
        }}
        placeholder={'Enter title'}
        value={quiz.title}
      />
      <Textarea
        label={'Description'}
        onChange={(value: string) => {
          ensureFormExists()
          if (quiz.form) {
            quiz.form.description = value
          }
        }}
        placeholder={'Enter description'}
        value={quiz.form?.description ?? undefined}
      />
    </>
  )
})

export { QuizBlockEditor }
